import { Component, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { SettingsOverviewDataProvider } from '@services/settings/settings-overview/settings-overview.data.service';
import { CompanySettingsList, SettingsOverview } from '@models/brands.model';

@Component({
	selector: 'settings-navigation',
	template: require('./settings-navigation.component.html'),
	styles: [require('./settings-navigation.component.scss')],
	encapsulation: ViewEncapsulation.None
})
export class SettingsNavigationComponent implements OnInit {
	showCompanySettings = false;
	showGlobalSettings = false;
	settingsLists: SettingsOverview;
	companySettingsList: CompanySettingsList;
	companySettingsType: CompanySettingsList[] = [];

	constructor(
		@Inject(DOCUMENT) private document: Document,
		private settingsOverviewService: SettingsOverviewDataProvider
	) {}

	ngOnInit(): void {
		this.getSettingsOverviewList();
	}

	checkActiveSettingsNavItem(url: string) {
		if (
			url === '/settings/companies' &&
			(this.document.location.pathname === '/settings/company/edit' ||
				this.document.location.pathname.includes('/settings/company/'))
		) {
			return true;
		}

		return this.document.location.pathname === url;
	}

	getSettingsOverviewList() {
		this.settingsOverviewService
			.settingsOverview()
			.filter(data => data !== null)
			.subscribe(data => {
				this.settingsLists = data;
				if (data.companySettings) {
					this.createCompanySettingsStructure(data);
				}
			});
	}

	private createCompanySettingsStructure(data): void {
		this.companySettingsType = [];
		const companySettingsTypes = [];
		data.companySettings.forEach(el => {
			companySettingsTypes.push(el.companySettingsType);
		});
		const newSet = new Set(companySettingsTypes);
		const setArray = [...newSet];

		setArray.forEach(el => {
			this.companySettingsList = {
				expandedIn: false,
				name: el,
				companySettingsList: [
					...data.companySettings.filter(obj => obj.companySettingsType === el)
				]
			};
			this.companySettingsType.push(this.companySettingsList);
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=os2z8rc99lf!./web/modern/components/settings/settings-overview/settings-navigation/settings-navigation.component.ts